import {StateObservableI} from './state-observable-i';
import {Subject} from 'rxjs';

export class StateObservable implements StateObservableI{
    public stateUpdate: Subject<void> = new Subject<void>();
    public trigger(): void {
        this.stateUpdate.next();
    }
}
